import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";

const PatDashEligTable = ({
  setEligibilityData,
  payerData,
  benefitData,
  objProviderData,
  receiverData,
  objPatData,
  subscriberData,
  addisubscriberData,
  coInsurance,
  coPayment,
  deductibleDta,
}) => {
  const formatEndDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const specificDate = new Date("01/01/1900");
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }

    if (date.getTime() === specificDate.getTime()) {
      return "";
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };
  return (
    <>
      <div className="gvheader" style={{ textAlign: "center" }}>
        Eligibility Details
      </div>
      <div>
        <label id="eligibilitmessageLabel"></label>
        <table
          width="100%"
          cellspacing="1"
          id="EligibilityReport"
          visible="false"
        >
          <tr className="rows">
            <td align="center" colspan="2">
              <b>Payer</b>
            </td>
          </tr>
          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Name:
            </td>
            <td width="70%">
              <b>
                <label ID="lblPayerName" style={{ paddingLeft: "5px" }}>
                  {" "}
                  {payerData.PayerName || ""}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Payer identification:
            </td>
            <td width="70%">
              <b>
                {payerData ? (
                  <label ID="lblIdentification" style={{ paddingLeft: "5px" }}>
                    {payerData.PayerID}
                  </label>
                ) : (
                  <label
                    ID="lblIdentification"
                    style={{ paddingLeft: "5px" }}
                  ></label>
                )}
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td colspan="2" style={{ borderBottom: "1px solid red" }}></td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Eligibility or Benefit:
            </td>
            <td width="70%">
              <table width="100%">
                <tr>
                  <td width="30%">
                    <b>
                      <label
                        ID="lblEBAC"
                        style={{
                          paddingLeft: "5px",
                          width: "160px",
                          color: "green",
                        }}
                      >
                        {benefitData[0]?.BenefitInfo || ""}
                      </label>
                      <label
                        ID="lblEBAC2"
                        style={{
                          paddingLeft: "5px",
                          width: "160px",
                          color: "green",
                        }}
                      >
                        {benefitData[1]?.BenefitInfo}
                      </label>
                    </b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Coverage:
            </td>
            <td width="70%">
              <table width="100%">
                <tr>
                  <td width="30%">
                    <b>
                      <label
                        ID="lblEBACCoverage"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      >
                        {benefitData[0]?.CoverageLevel}
                      </label>
                    </b>
                  </td>
                  <td>
                    <b>
                      <label
                        ID="lblEBACCoverage2"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      ></label>
                    </b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Service Type:
            </td>
            <td width="70%">
              <table width="100%">
                <tr>
                  <td width="30%">
                    <b>
                      <label
                        ID="lblEBACServicetype"
                        style={{ paddingLeft: "5px", width: "85%" }}
                      >
                        {benefitData[0]?.ServiceType}
                      </label>
                    </b>
                  </td>
                  <td>
                    <b>
                      <label
                        ID="lblEBACServicetype2"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      ></label>
                    </b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Insurance Type:
            </td>
            <td width="70%">
              <table width="100%">
                <tr>
                  <td width="30%">
                    <b>
                      <label
                        ID="lblEBACInsurancetype"
                        style={{ paddingLeft: "5px", width: "auto" }}
                      >
                        {benefitData[0]?.InsuranceType}
                      </label>
                    </b>
                  </td>
                  <td>
                    <b>
                      <label
                        ID="lblEBACInsurancetype2"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      ></label>
                    </b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Plan Coverage Description:
            </td>
            <td width="70%">
              <table width="100%">
                <tr>
                  <td width="30%">
                    <b>
                      <label
                        ID="lblEBACPlanCdesc"
                        style={{ paddingLeft: "5px", width: "auto" }}
                      >
                        {benefitData[0]?.PlanCoverageDescription}
                      </label>
                    </b>
                  </td>
                  <td>
                    <b>
                      <label
                        ID="lblEBACPlanCdesc2"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      ></label>
                    </b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Eligibility Begin:
            </td>
            <td width="70%">
              <table width="100%">
                <tr>
                  <td width="30%">
                    <b>
                      <label
                        ID="lblEBACPEB"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      ></label>
                    </b>
                  </td>
                  <td>
                    <b>
                      <label
                        ID="lblEBACPEB2"
                        style={{ paddingLeft: "5px", width: "35%" }}
                      ></label>
                    </b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr className="rows">
            <td colspan="2" style={{ borderBottom: "1px solid red" }}></td>
          </tr>

          <tr className="rows">
            <td align="center" colspan="2">
              <b>Information Receiver</b>
            </td>
          </tr>
          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Type:
            </td>
            <td width="70%">
              <b>
                <label ID="lblrecType" style={{ paddingLeft: "5px" }}></label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Name:
            </td>
            <td width="70%">
              <b>
                <label ID="lblrecName">{objProviderData.LastName}</label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              National provider identifier(NPI):
            </td>
            <td width="70%">
              <b>
                <label ID="lblrecnpi" style={{ paddingRight: "5px" }}>
                  {receiverData.NPI}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td colspan="2" style={{ borderBottom: "1px solid red" }}></td>
          </tr>

          <tr className="rows">
            <td align="center" colspan="2">
              <b>Insured or Subscriber</b>
            </td>
          </tr>
          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Name:
            </td>
            <td width="70%">
              <b>
                {objPatData ? (
                  <label ID="lblIORName" style={{ paddingLeft: "5px" }}>
                    {objPatData.LastName},{objPatData.FirstName}
                  </label>
                ) : (
                  <label ID="lblIORName" style={{ paddingLeft: "5px" }}></label>
                )}
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Member Identification Number:
            </td>
            <td width="70%">
              <b>
                <label ID="lblIORMIN" style={{ paddingLeft: "5px" }}>
                  {subscriberData.PolicyNumber}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Case Number:
            </td>
            <td width="70%">
              <b>
                <label ID="lblIORCaseNumber" style={{ paddingLeft: "5px" }}>
                  {addisubscriberData.GroupPolicyNumber}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Description:
            </td>
            <td width="70%">
              <b>
                <label ID="lblIORDesc" style={{ paddingLeft: "5px" }}>
                  {addisubscriberData.PlansSponsor}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Address:
            </td>
            <td width="70%">
              <b>
                {objPatData ? (
                  <label ID="lblIORAddress" style={{ paddingLeft: "5px" }}>
                    {objPatData.Address},{objPatData.City},{objPatData.State},
                    {objPatData.Zip}
                  </label>
                ) : (
                  <label></label>
                )}
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              DOB:
            </td>
            <td width="70%">
              <b>
                <label ID="lblIORDOB" style={{ paddingLeft: "5px" }}>
                  {formatEndDate(subscriberData.DOB)}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Gender:
            </td>
            <td width="70%">
              <b>
                <label ID="lblIORGender" style={{ paddingLeft: "5px" }}>
                  {subscriberData.Gender}
                </label>
              </b>
            </td>
          </tr>

          <tr className="rows">
            <td colspan="2" style={{ borderBottom: "1px solid red" }}></td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Eligibility or Benefit:
            </td>
            <td width="70%">
              {coInsurance ? (
                <>
                  <label
                    ID="lblCOINEOB"
                    style={{ paddingLeft: "5px", color: "purple" }}
                  >
                    Co-Insurance
                  </label>
                  <label
                    ID="lblCOINEOB2"
                    style={{ paddingLeft: "5px", color: "purple" }}
                  >
                    Co-Insurance
                  </label>
                </>
              ) : (
                <>
                  <label ID="lblCOINEOB" style={{ paddingLeft: "5px" }}></label>
                  <label
                    ID="lblCOINEOB2"
                    style={{ paddingLeft: "5px" }}
                  ></label>
                </>
              )}
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Coverage:
            </td>
            <td width="70%">
              <label ID="lblCOINCoverage" style={{ paddingLeft: "5px" }}>
                {coInsurance[0]?.CoverageLevel}
              </label>
              <label ID="lblCOINCoverage2" style={{ paddingLeft: "5px" }}>
                {coInsurance[1]?.CoverageLevel}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Service Type:
            </td>
            <td width="70%">
              <label ID="lblCOINServicetype" style={{ paddingLeft: "5px" }}>
                {coInsurance[0]?.ServiceType}
              </label>
              <label ID="lblCOINServicetype2" style={{ paddingLeft: "5px" }}>
                {coInsurance[1]?.ServiceType}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Insurance Type:
            </td>
            <td width="70%">
              <label ID="lblCOINInsurancetype" style={{ paddingLeft: "5px" }}>
                {coInsurance[0]?.InsuranceType}
              </label>
              <label ID="lblCOINInsurancetype2" style={{ paddingLeft: "5px" }}>
                {coInsurance[1]?.InsuranceType}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Plan Coverage Description:
            </td>
            <td width="70%">
              <label ID="lblCOINPCD" style={{ paddingLeft: "5px" }}>
                {coInsurance[0]?.PlanCoverageDescription}
              </label>
              <label ID="lblCOINPCD2" style={{ paddingLeft: "5px" }}>
                {coInsurance[1]?.PlanCoverageDescription}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Percent:
            </td>
            <td width="70%">
              <label ID="lblCOIPercent" style={{ paddingLeft: "5px" }}>
                {coInsurance[0]?.Percentage}
              </label>
              <label ID="lblCOIPercent2" style={{ paddingLeft: "5px" }}>
                {coInsurance[1]?.Percentage}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td colspan="2" style={{ borderBottom: "1px solid red" }}></td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Eligibility or Benefit:
            </td>
            <td width="70%">
              {coPayment ? (
                <>
                  <label
                    ID="lblCOPAYEOB"
                    style={{ paddingLeft: "5px", color: "purple" }}
                  >
                    Co-Payment
                  </label>
                  <label
                    ID="lblCOPAYEOB2"
                    style={{ paddingLeft: "5px", color: "purple" }}
                  >
                    Co-Payment
                  </label>
                </>
              ) : (
                <>
                  <label
                    ID="lblCOPAYEOB"
                    style={{ paddingLeft: "5px" }}
                  ></label>
                  <label
                    ID="lblCOPAYEOB2"
                    style={{ paddingLeft: "5px" }}
                  ></label>
                </>
              )}
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Coverage:
            </td>
            <td width="70%">
              <label ID="lblCOPAYCoverage" style={{ paddingLeft: "5px" }}>
                {coPayment[0]?.CoverageLevel}
              </label>
              <label ID="lblCOPAYCoverage2" style={{ paddingLeft: "5px" }}>
                {coPayment[1]?.CoverageLevel}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Service Type:
            </td>
            <td width="70%">
              <label ID="lblCOPAYServicetype" style={{ paddingLeft: "5px" }}>
                {coPayment[0]?.ServiceType}
              </label>
              <label ID="lblCOPAYServicetype2" style={{ paddingLeft: "5px" }}>
                {coPayment[1]?.ServiceType}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Insurance Type:
            </td>
            <td width="70%">
              <label ID="lblCOPAYItype" style={{ paddingLeft: "5px" }}>
                {coPayment[0]?.InsuranceType}
              </label>
              <label ID="lblCOPAYItype2" style={{ paddingLeft: "5px" }}>
                {coPayment[1]?.InsuranceType}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Plan Coverage Description:
            </td>
            <td width="70%">
              <label ID="lblCOPAYPCD" style={{ paddingLeft: "5px" }}>
                {coPayment[0]?.PlanCoverageDescription}
              </label>
              <label ID="lblCOPAYPCD2" style={{ paddingLeft: "5px" }}>
                {coPayment[1]?.PlanCoverageDescription}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Monetary Amount:
            </td>
            <td width="70%">
              <label ID="lblCOPAYMAmount" style={{ paddingLeft: "5px" }}>
                {coPayment[0]?.BenefitAmount}
              </label>
              <label ID="lblCOPAYMAmount2" style={{ paddingLeft: "5px" }}>
                {coPayment[1]?.BenefitAmount}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td colspan="2" style={{ borderBottom: "1px solid red" }}></td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Eligibility or Benefit:
            </td>
            <td width="70%">
              {deductibleDta ? (
                <>
                  <label
                    ID="lblSecDeductEOB"
                    style={{ paddingLeft: "5px", color: "purple" }}
                  >
                    Deductible
                  </label>
                  <label
                    ID="lblSecDeductEOB2"
                    style={{ paddingLeft: "5px", color: "purple" }}
                  >
                    Deductible
                  </label>
                </>
              ) : (
                <>
                  <label
                    ID="lblSecDeductEOB"
                    style={{ paddingLeft: "5px" }}
                  ></label>
                  <label
                    ID="lblSecDeductEOB2"
                    style={{ paddingLeft: "5px" }}
                  ></label>
                </>
              )}
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Coverage:
            </td>
            <td width="70%">
              <label ID="lblDeductCoverage" style={{ paddingLeft: "5px" }}>
                {deductibleDta[0]?.CoverageLevel}
              </label>
              <label ID="lblDeductCoverage2" style={{ paddingLeft: "5px" }}>
                {deductibleDta[1]?.CoverageLevel}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Service Type:
            </td>
            <td width="70%">
              <label
                ID="lblSecDeductServicetype"
                style={{ paddingLeft: "5px" }}
              >
                {deductibleDta[0]?.ServiceType}
              </label>
              <label
                ID="lblSecDeductServicetype2"
                style={{ paddingLeft: "5px" }}
              >
                {deductibleDta[1]?.ServiceType}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Insurance Type:
            </td>
            <td width="70%">
              <label
                ID="lblSecDeductInsurancetype"
                style={{ paddingLeft: "5px" }}
              >
                {deductibleDta[0]?.InsuranceType}
              </label>
              <label
                ID="lblSecDeductInsurancetype2"
                style={{ paddingLeft: "5px" }}
              >
                {deductibleDta[1]?.InsuranceType}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Plan Coverage Description:
            </td>
            <td width="70%">
              <label ID="lblDeductPCD" style={{ paddingLeft: "5px" }}>
                {deductibleDta[0]?.PlanCoverageDescription}
              </label>
              <label ID="lblDeductPCD2" style={{ paddingLeft: "5px" }}>
                {deductibleDta[1]?.PlanCoverageDescription}
              </label>
            </td>
          </tr>

          <tr className="rows">
            <td align="right" width="30%" style={{ paddingRight: "5px" }}>
              Monetary Amount:
            </td>
            <td width="70%">
              <label ID="lblSecDeductMA" style={{ paddingLeft: "5px" }}>
                {deductibleDta[0]?.BenefitAmount}
              </label>
              <label ID="lblSecDeductMA2" style={{ paddingLeft: "5px" }}>
                {deductibleDta[1]?.BenefitAmount}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default PatDashEligTable;
